<template>
    <div>
        <div class="row form-group">
            <label for="registered_eligible" class="col-md-2">
                Registered Plan Eligibility
            </label>
            <div class="col-md-8">
                <label class="checkbox-inline">
                    <input type="checkbox" 
                           name="registered_eligible" 
                           v-model="registeredEligible"
                           value="1"> 
                    Registered Plan Eligible?
                </label>
            </div>
            <div class="col-md-8">
                <label class="checkbox-inline">
                    <input type="checkbox" 
                           name="offline_registered_documents" 
                           :checked="offlineRegisteredDocuments"
                           value="1"> 
                    Offline Registered documents
                </label>
            </div>
        </div>
        
        <div class="row form-group" v-if="registeredEligible">
            <label for="trustees" class="col-md-2">
                Available Trustees
            </label>
            <div class="col-md-8">
                <label v-for="trustee in trustees" :key="trustee.id" class="checkbox-inline">
                    <input type="checkbox" 
                           :name="'trustees[' + trustee.id + ']'"
                           v-model="selectedTrustees"
                           :value="trustee.id"
                           value="1"> 
                    {{ trustee.name }}
                </label>
            </div>
        </div>
        
        <div class="row form-group" v-if="registeredEligible && showOlympiaFields">
            <label for="olympia_trust_fields" class="col-md-2 control-label">
                Olympia Trust Fields
                <span class="help-tip" @click="showTooltip = !showTooltip">
                    <span class="glyphicon glyphicon-question-sign"></span>
                    <div v-if="showTooltip" class="help-tip-text help-tip-right">
                        <div class="help-tip-wide help-tip-smaller">
                            These fields will be merged into Olympia Trust registered plan documents when signing. Both fields are optional and only used for specific Olympia Trust forms.
                        </div>
                    </div>
                </span>
            </label>
            <div class="col-md-8">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="col-md-4 control-label">Fund Code</label>
                            <div class="col-md-8">
                                <input type="text" 
                                       name="olympia_fund_code" 
                                       class="form-control"
                                       :value="olympiaFundCode"
                                       placeholder="Enter fund code">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="col-md-4 control-label">Issue Date</label>
                            <div class="col-md-8">
                                <input type="date" 
                                       name="olympia_issue_date" 
                                       class="form-control"
                                       :value="olympiaIssueDate"
                                       placeholder="YYYY-MM-DD">
                            </div>
                        </div>
                    </div>
                </div>
                <small class="form-text text-muted">These fields are optional and only required for specific Olympia Trust forms.</small>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TrusteeSelector',
    props: {
        initialRegisteredEligible: {
            type: Boolean,
            default: false
        },
        offlineRegisteredDocuments: {
            type: Boolean,
            default: false
        },
        trustees: {
            type: Array,
            required: true
        },
        initialSelectedTrustees: {
            type: Array,
            default: () => []
        },
        olympiaFundCode: {  // Changed from olympiaFormCode
            type: String,
            default: ''
        },
        olympiaIssueDate: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            registeredEligible: this.initialRegisteredEligible,
            selectedTrustees: [...this.initialSelectedTrustees],
            showTooltip: false
        }
    },
    computed: {
        showOlympiaFields() {
            // Check if any selected trustees have "olympia" in their name
            return this.selectedTrustees.some(trusteeId => {
                const trustee = this.trustees.find(t => t.id === trusteeId);
                return trustee && trustee.name.toLowerCase().includes('olympia');
            });
        }
    },
    mounted() {
        // Close tooltip when clicking outside
        document.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.showTooltip = false;
            }
        });
    }
}
</script>

<style>
.help-tip-right {
    left: 30px !important;
    right: auto !important;
}

.help-tip-smaller {
    font-size: 14px !important;
    line-height: 1.4 !important;
}
</style>